import { pageLevelLocalization } from '@/constant/localization';

type RatingLabelProps = {
  score: number;
};
const { product: productLocalization } = pageLevelLocalization;

export default function RatingLabel({ score }: RatingLabelProps) {
  let label = '';
  let colorClass = '';

  if (score >= 4 && score <= 5) {
    label = productLocalization.excellent;
    colorClass = 'text-[#549612]';
  } else if (score >= 3 && score < 4) {
    label = productLocalization.good;
    colorClass = 'text-[#81CF33]';
  } else if (score >= 2 && score < 3) {
    label = productLocalization.medium;
    colorClass = 'text-[#FFB616]';
  } else if (score >= 1 && score < 2) {
    label = productLocalization.poor;
    colorClass = 'text-[#FF6437]';
  }

  return <span className={`font-bold ${colorClass}`}>{label}</span>;
}
